var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10515",
    "data-name": "Group 10515",
    transform: "translate(-31.999 -247.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "categories",
    d: "M22.8,4.255V9.345A1.532,1.532,0,0,1,21.2,10.8H4.4A1.532,1.532,0,0,1,2.8,9.345V4.255A1.532,1.532,0,0,1,4.4,2.8H21.2A1.532,1.532,0,0,1,22.8,4.255Z",
    transform: "translate(29.199 245.199)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "categories-2",
    "data-name": "categories",
    d: "M31.319,14.053v5.091a1.532,1.532,0,0,1-1.6,1.455h-16.8a1.532,1.532,0,0,1-1.6-1.455V14.053a1.532,1.532,0,0,1,1.6-1.455h16.8A1.532,1.532,0,0,1,31.319,14.053Z",
    transform: "translate(20.68 247.402)",
    fill: "#404040"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.614441cd93b227d62daa64b6e3903bb2.svg";
export { ForwardRef as ReactComponent };